<template>
  <v-layout row wrap>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand>
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.clmSubNo" :label="labels.clmSubNo" type="tel" :error-messages="errors.collect('clmSubNo')"
                        data-vv-name="clmSubNo" :data-vv-as="labels.clmSubNo" v-validate="'numeric'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.clmRefNo" :label="labels.clmRefNo" type="tel" :error-messages="errors.collect('clmRefNo')"
                        data-vv-name="clmRefNo" :data-vv-as="labels.clmRefNo" v-validate="'numeric'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.polNo" :label="labels.polNo" :error-messages="errors.collect('polNo')" data-vv-name="polNo" :data-vv-as="labels.polNo"
                        v-validate="'entry|max:16'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-int-mask="{intScale: 11}" v-model="filters.propNo" :label="labels.propNo" type="tel" :error-messages="errors.collect('propNo')"
                        data-vv-name="propNo" :data-vv-as="labels.propNo" v-validate="'numeric'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.insdName" :label="labels.insdName" :error-messages="errors.collect('insdName')" data-vv-name="insdName" :data-vv-as="labels.insdName"
                        v-validate="'entry|max:16'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <cal-picker v-model="filters.lossDate" :label="labels.lossDate" data-vv-name="lossDate" :data-vv-as="labels.lossDate"
                        :error-messages="errors.collect('lossDate')" />
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <cal-picker v-model="filters.createdDate" :label="labels.createdDate" data-vv-name="createdDate" :data-vv-as="labels.createdDate"
                        :error-messages="errors.collect('createdDate')" />
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.status" v-model="filters.status" :label="labels.status" item-text="label" item-value="value" data-vv-name="status" :data-vv-as="labels.status"
                        :error-messages="errors.collect('status')" clearable></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-flex xs12 class="mt-2">
      <v-data-table :headers="headers" :items="items" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" class="elevation-1"
        :rows-per-page-items="itemsPerPage" :no-data-text="noDataText">
        <template slot="items" slot-scope="props">
          <td v-for="column in columns" :key="column.value">
            {{props.item[column.value]}}
          </td>
          <td class="text-xs-right">
            <table-action :rowData="props" :review="canReview(props)" @review="doReview(props)"
              :query="checkAccess(['fireClaimQuery'])" @query="doQuery(props)" :loading="loading"/>
          </td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import clone from 'clone'
import { expandURI, filterQuery } from '@/utils/ajax'
import { mapGetters } from 'vuex'
import { removeTime, setEndTime, formatDisplayDateTime2 } from '@/utils/date'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export default {
  mounted() {
    this.fetchData(false)
  },
  data() {
    return {
      totalItems: 0,
      headers: [
        { text: 'Claim Submission No.', value: 'clmSubNo' },
        { text: 'Claim Reference No.', value: 'clmRefNo' },
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Certificate No.', value: 'propNo' },
        { text: 'Policy Holder', value: 'insdName' },
        { text: 'Loss Date', value: 'lossDate' },
        { text: 'Submitted Date', value: 'createdDate' },
        { text: 'Status', value: 'statusDisplay' },
        TableConst.tableActionHeader
      ],
      columns: [
        { align: 'left', value: 'clmSubNo' },
        { align: 'left', value: 'clmRefNo' },
        { value: 'polNo' },
        { align: 'left', value: 'propNo' },
        { value: 'insdName' },
        { value: 'lossDate' },
        { value: 'createdDate' },
        { value: 'statusDisplay' }
      ],
      labels: {
        clmSubNo: 'Claim Submission No.',
        clmRefNo: 'Claim Reference No.',
        polNo: 'Policy No.',
        propNo: 'Certificate No.',
        insdName: 'Policy Holder',
        lossDate: 'Loss Date',
        createdDate: 'Submitted Date',
        status: 'Status'
      },
      statusCodeMap: {
        'N': 'New',
        'C': 'Converted'
      },
      filters: {
        clmSubNo: null,
        clmRefNo: null,
        polNo: null,
        propNo: null,
        insdName: null,
        lossDate: null,
        createdDate: null,
        status: null
      },
      params: {
        status: [
          { label: 'New', value: 'N' },
          { label: 'Converted', value: 'C' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    menu() {
      return this.$store.state.claimStaging.menu
    }
  },
  methods: {
    async fetchData(options) {
      if (this.apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage,
            options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.lossFrom) {
            massageFilters.lossFrom = formatDisplayDateTime2(removeTime(massageFilters.lossFrom))
          }
          if (massageFilters.lossTo) {
            massageFilters.lossTo = formatDisplayDateTime2(setEndTime(massageFilters.lossTo))
          }
          if (massageFilters.entryFrom) {
            massageFilters.entryFrom = formatDisplayDateTime2(removeTime(massageFilters.entryFrom))
          }
          if (massageFilters.entryTo) {
            massageFilters.entryTo = formatDisplayDateTime2(setEndTime(massageFilters.entryTo))
          }
          const result = await this.$http.get(filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))

          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((claim) => {
                const convertClaim = {
                  clmSubNo: claim.clmSubNo,
                  clmRefNo: claim.clmRefNo,
                  polNo: claim.polNo,
                  propNo: claim.propNo,
                  status: claim.status,
                  statusDisplay: this.statusCodeMap[claim.status] || claim.status,
                  lossDate: this.formatDate(claim.lossDate),
                  createdDate: this.formatDate(claim.createdDate),
                  insdName: claim.insdName,
                  isPolHdrClmt: claim.isPolHdrClmt
                }
                this.items.push(convertClaim)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doQuery(data) {
      this.$router.push({ name: 'fireClaimStagingQuery', params: { id: data.item.clmSubNo } })
    },
    canReview(data) {
      if (this.checkAccess(['fireClaim'])) {
        if (data.item.status !== 'C') {
          return true
        }
      }
      return false
    },
    async doReview(data) {
      this.$router.push({ name: 'fireClaimStagingReview', params: { id: data.item.clmSubNo } })
    },
    doClearFilters() {
      this.filters.clmSubNo = null
      this.filters.clmRefNo = null
      this.filters.polNo = null
      this.filters.propNo = null
      this.filters.insdName = null
      this.filters.lossDate = null
      this.filters.createdDate = null
      this.filters.status = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    }
  },
  created() {
    this.apiUrl = this.menu.fire
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
